import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Authorized from "components/Authorized";
import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import FormDialog from "components/modals/FormDialog";
import {
  deleteProductLine,
  invalidateProductLinesQuery,
} from "hooks/useProductLinesTable";
import ProductLineForm from "routes/product_line/ProductLineForm";

const EDIT_ACLS = [ACL_RELATIONSHIPS.productLine.edit];
const DELETE_ACLS = [ACL_RELATIONSHIPS.productLine.delete];
const ANY_ACLS = [...EDIT_ACLS, ...DELETE_ACLS];

export function ProductLinesTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const handleDelete = async () => {
    try {
      await deleteProductLine(original.id);
      toast.success("Product Line deleted");
      setDeleteOpen(false);
    } catch {
      toast.error("Failed to delete Product Line");
    }
  };

  return (
    <Authorized permissions={ANY_ACLS} partialMatch>
      <>
        <DropdownMenu>
          <DropdownMenuTrigger
            aria-label="Product line actions"
            className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
          >
            <Ellipsis />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <Authorized permissions={EDIT_ACLS}>
              <DropdownMenuItem onClick={() => setEditOpen(true)}>
                <Pencil />
                Edit
              </DropdownMenuItem>
            </Authorized>
            <Authorized permissions={DELETE_ACLS}>
              <DropdownMenuItem
                variant="destructive"
                onClick={() => setDeleteOpen(true)}
              >
                <Trash2 />
                Delete
              </DropdownMenuItem>
            </Authorized>
          </DropdownMenuContent>
        </DropdownMenu>
        <FormDialog
          FormComponent={ProductLineForm}
          model={original}
          modelType="Product Line"
          open={editOpen}
          onOpenChange={setEditOpen}
          onSuccess={invalidateProductLinesQuery}
        />
        <ConfirmDeleteDialog
          open={deleteOpen}
          onOpenChange={setDeleteOpen}
          title="Delete Product Line?"
          description="Are you sure you want to delete this Product Line?"
          onConfirm={handleDelete}
        />
      </>
    </Authorized>
  );
}
